/**
 * Dependencies
 */
import customTable from '../../../digital-om/components/models/custom-tables.js'
import { cloneDeep } from 'lodash'

/**
 * War Room State
 *
 * @type {Object}
 */
const state = {
    isEditing: false,
    showMenu: false,
    showLayoutModal: false,
    showComponentModal: false,
    showPanel: false,
    meta: {},
    warRoomId: null,
    digitalOM: {
        sections: []
    },
    pageSelection: {
        showModal: false,
        sectionId: null,
        sectionIndex: null,
        pageId: null,
        pageIndex: null
    },
    layouts: [
        { name: 'layout_one', components: 4 },
        { name: 'layout_two', components: 3 },
        { name: 'layout_three', components: 2 },
        { name: 'layout_four', components: 3 },
        { name: 'layout_five', components: 2 },
        { name: 'layout_six', components: 3 },
        { name: 'layout_seven', components: 1 },
        { name: 'layout_eight', components: 3 },
        { name: 'layout_nine', components: 9 },
        { name: 'layout_ten', components: 6 }
    ],
    defaults: {
        'map': {
            type: 'map',
            value: {
                points: [],
                style: 'mapbox://styles/mapbox/streets-v9',
                center: [-97.922211, 39.381266],
                zoom: 3,
                radius: 1
            }
        },
        'text': {
            type: 'text',
            value: {
                body: [
                    {
                        text: '',
                        attributes: []
                    }
                ]
            }
        },
        'image': {
            type: 'image',
            value: {}
        },
        'table': {
            type: 'table',
            value: {
                headers: [null, null],
                rows: [
                    {
                        values: [
                            { data: null, format: 'string' },
                            { data: null, format: 'number' }
                        ],
                        is_total: false,
                        is_subtotal: false,
                        stylings: []
                    },
                    {
                        values: [
                          { data: null, format: 'string' },
                          { data: null, format: 'number' }
                        ],
                        is_total: false,
                        is_subtotal: false,
                        stylings: []
                    },
                    {
                        values: [
                            { data: null, format: 'string' },
                            { data: null, format: 'number' }
                        ],
                        is_total: true,
                        is_subtotal: false,
                        stylings: []
                    }
                ]
            }
        },
        'custom_table_box': {
            type: 'custom_table_box',
            value: cloneDeep(customTable)
        },
        'generated_table': {
            type: 'generated_table',
            value: cloneDeep(customTable)
        }
    }
}

/**
 * Return a fresh copy of the base state
 *
 * @return {Object}
 */
export const getState = () => cloneDeep(state)

export default getState()



// WEBPACK FOOTER //
// ./src/state/modules/dom/state.js